const ALL_TROOP_ATTACK_UP_EFFECT_ID = 50397254;
const ALL_TROOP_HP_UP_EFFECT_ID = 50397255;
const ALL_TROOP_DEFENSE_UP_EFFECT_ID = 50397279;
const FLEET_TROOPS_UNITS_BONUS_LIMIT_EFFECT_ID = 50462870;

// Ported from storePackCatalog.generated.json; percent values use the game's internal /10 scale.
const allTroopEffects = (entries = []) => entries.map(([effectId, value]) => ({ effectId, value }));

const createNationBuff = ({
  itemGid,
  name,
  durationSeconds,
  durationLabel,
  description,
  effects,
  aliases = [],
}) => ({
  itemGid,
  name,
  category: "nation",
  categoryLabel: "Nation",
  description,
  aliases,
  durationOptions: [{
    level: 0,
    durationSeconds,
    durationLabel,
    quality: 4,
    effects,
  }],
  effects,
});

export const NATION_BUFF_CATALOG = [
  createNationBuff({
    itemGid: 68419596,
    name: "Nation with 3 Wins Statue",
    durationSeconds: 864000,
    durationLabel: "10 days",
    description: "Nation reward statue: Attack, HP, and Defense of all Troops +5%.",
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 50],
      [ALL_TROOP_HP_UP_EFFECT_ID, 50],
      [ALL_TROOP_DEFENSE_UP_EFFECT_ID, 50],
    ]),
  }),
  createNationBuff({
    itemGid: 68419597,
    name: "Nation with 2 Wins Statue",
    durationSeconds: 864000,
    durationLabel: "10 days",
    description: "Nation reward statue: Attack, HP, and Defense of all Troops +3%.",
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 30],
      [ALL_TROOP_HP_UP_EFFECT_ID, 30],
      [ALL_TROOP_DEFENSE_UP_EFFECT_ID, 30],
    ]),
  }),
  createNationBuff({
    itemGid: 68419598,
    name: "Nation Duel Gold Statue",
    durationSeconds: 604800,
    durationLabel: "7 days",
    description: "Nation Duel statue: Attack, HP, and Defense of all Troops +8%.",
    aliases: ["Full Upgrade"],
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 80],
      [ALL_TROOP_HP_UP_EFFECT_ID, 80],
      [ALL_TROOP_DEFENSE_UP_EFFECT_ID, 80],
    ]),
  }),
  createNationBuff({
    itemGid: 68419599,
    name: "Nation Duel Silver Statue",
    durationSeconds: 604800,
    durationLabel: "7 days",
    description: "Nation Duel statue: Attack, HP, and Defense of all Troops +5%.",
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 50],
      [ALL_TROOP_HP_UP_EFFECT_ID, 50],
      [ALL_TROOP_DEFENSE_UP_EFFECT_ID, 50],
    ]),
  }),
  createNationBuff({
    itemGid: 68419600,
    name: "Nation Duel Bronze Statue",
    durationSeconds: 604800,
    durationLabel: "7 days",
    description: "Nation Duel statue: Attack, HP, and Defense of all Troops +3%.",
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 30],
      [ALL_TROOP_HP_UP_EFFECT_ID, 30],
      [ALL_TROOP_DEFENSE_UP_EFFECT_ID, 30],
    ]),
  }),
  createNationBuff({
    itemGid: 68419601,
    name: "Group Buying Star Highest Points Nation Reward",
    durationSeconds: 0,
    durationLabel: "event reward",
    description: "Observed nation reward: Fleet Troops Units Bonus Limit +2,000.",
    effects: allTroopEffects([
      [FLEET_TROOPS_UNITS_BONUS_LIMIT_EFFECT_ID, 2000],
    ]),
  }),
];

export default NATION_BUFF_CATALOG;
